import { useState, useEffect } from 'react';
import isEqual from 'lodash/isEqual';

const useStoreData = (defaultStore) => {
  const [storeData, setStoreData] = useState({});

  if (defaultStore && !isEqual(storeData, defaultStore)) {
    setStoreData(defaultStore);
  }

  useEffect(() => {
    if (!defaultStore) {
      setStoreData(defaultStore);
    }
  }, [defaultStore]);

  return storeData;
};

export default useStoreData;
